import { render, staticRenderFns } from "./xzcfspb.vue?vue&type=template&id=32498b4e&scoped=true&"
import script from "./xzcfspb.vue?vue&type=script&lang=js&"
export * from "./xzcfspb.vue?vue&type=script&lang=js&"
import style0 from "./xzcfspb.vue?vue&type=style&index=0&id=32498b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32498b4e",
  null
  
)

export default component.exports